/**
 * Test a model preset using the queue-centric architecture.
 * Calls the debug-gen-text Edge Function and polls for completion.
 */
import { waitForJob } from './queueJob';
import { getEdgeFunctionAuthHeaders } from './supabase';

export async function testModelPreset(
  presetKey: string,
  prompt: string = 'say hi'
) {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

  // Call the debug-gen-text Edge Function to create a queue job
  const createResponse = await fetch(
    `${supabaseUrl}/functions/v1/debug-gen-text`,
    {
      method: 'POST',
      headers: await getEdgeFunctionAuthHeaders(),
      body: JSON.stringify({
        promptTemplate: prompt,
        modelPresetId: presetKey,
        parameters: {},
        promptId: 'preset-test',
      }),
    }
  );

  if (!createResponse.ok) {
    const errorText = await createResponse.text();
    throw new Error(`Failed to create test job: ${errorText}`);
  }

  const data = await createResponse.json();

  if (!data.success) {
    throw new Error(data.error || 'Failed to create test job');
  }

  const { jobId } = data.result;

  // Poll for completion (timeout: 30 seconds for simple preset test)
  const result = await waitForJob(jobId, {
    timeoutMs: 30000,
    pollIntervalMs: 1000,
  });

  if (result.outcome === 'completed') {
    // Pre-#739 the polled row was untyped JSON (any); keep that return shape
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const output = result.job.output as any;
    return output?.result || output;
  }

  if (result.outcome === 'failed') {
    throw new Error(result.job.last_error || 'Test failed');
  }

  if (result.outcome === 'timeout') {
    throw new Error('Preset test timed out');
  }

  // poll_error / aborted
  throw new Error(result.error);
}
